import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
//import { Button, Form, Row, Col } from 'react-bootstrap';
import default_avatar from "../../assets/images/default-avatar.jpg";
import diamond from "../../assets/images/diamond.png";
import TooltipHelp from '../notifications/tooltiphelp.component';
import { IUserOptionalData } from '../../interfaces/authentication';
//import countries from "countries-list";
import Notification, { notificationImages } from '../notifications/notification.component';
import { INotification, ITooltip, NotificationType } from '../../interfaces/notification';
import PhotoUploader from '../profile/photo-uploader.component';
import DatePicker from "react-datepicker";
import Icon from '@mdi/react';
import { mdiCalendar, mdiChevronRight  } from '@mdi/js';
import checkUnderAge from '../../_helper/check-underage';
//import Switch from "react-switch";
//import UniqueSimpleSelect from '../_helper/unique-simple-select.component';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { ESubscriptionStatus } from '../../interfaces/subscription';
import instance from '../../api/api';
//import HubspotContactModal from '../settings/hubspot-contact.modal';
//import { Link } from 'react-router-dom';
import moment from "moment"

/**
 * Local interface for input properties.
 */
interface IDetails {
    setUserDetails:Function
    userDetails:IUserOptionalData
    updateUserData:Function
    subscriptionData?:any
    isMailchimpSubscribed:boolean
    lang?:string
}

/**
 * Saved user load from cookie
 * @param props : ISavedUser interface
 * @returns void
 */
function DetailedRegistrationInformation(props:IDetails) {

    const [ tooltip, setTooltip ] = useState<boolean>(false);
    const [ notification, setNotification ] = useState<boolean>(false);
    const [ profilePicture, setProfilePicture ] = useState<string>('');
    const [ inputError, setInputError ] = useState<{firstname: string, lastname: string}>({firstname: '', lastname: ''});

    // Prefill profile picture from props if available
    useEffect(() => {
        if (props.userDetails.avatar) {
                setProfilePicture(props.userDetails.avatar as string);
        }
    }, [props.userDetails.avatar]);

    //const [ monthlyNewsletter, setMonthlyNewsletter ] = useState<boolean>(false);

    const [showHubspotModal, setShowHubspotModal] = useState(false)

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const { t } = useTranslation();
    const navigate = useNavigate();

    // Load FastSpring script if there's subscription data or if newsletter is selected
    useEffect(() => {
        if((props.subscriptionData && (props.subscriptionData.referral || props.subscriptionData.familyVip)) || props.userDetails.newsletter) {
            addFastSpringScript();
        }

        return () => {
            //remove fastspring script
            if(window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_SCRIPT_ID) {
                const script = document.getElementById(window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_SCRIPT_ID);

                if (script && script.parentNode) {
                    script.parentNode.removeChild(script);
                }
            }
        }
    }, [props.userDetails.newsletter])

    const tooltipData : ITooltip = {
        title: t("What's this?"),
        subtitle:t("Your data usage"),
        text: () => <p>{t("Unlike many modern platforms, Simirity does not use your personal data. This is a private service where your data is used by family only. This optional information is asked only to enhance the service for your family.")}</p>,
        clear: () => setTooltip(false),
        show: tooltip,
    }

    async function handleAction() {
        // Reset errors
        setInputError({firstname: '', lastname: ''});

        // Validate firstname and lastname
        let hasError = false;
        if(!props.userDetails.firstname || !props.userDetails.firstname.trim()) {
            setInputError(prev => ({...prev, firstname: t("First name is required")}));
            hasError = true;
        }
        if(!props.userDetails.lastname || !props.userDetails.lastname.trim()) {
            setInputError(prev => ({...prev, lastname: t("Last name is required")}));
            hasError = true;
        }

        if(hasError) {
            return;
        }

        await props.updateUserData();

        // Handle subscription flow if subscription data exists
        if(props.subscriptionData) {
            if(props.subscriptionData.referral) {
                const subscriptionRes = await instance.get("/subscriptions/" + props.subscriptionData.referral);
                if(subscriptionRes.data.status !== ESubscriptionStatus.INACTIVE) {
                    subscribe();
                    return; // Don't call nextStep, FastSpring will handle navigation
                }
            }
            else if(props.subscriptionData.familyVip){
                subscribeFamilyVip();
                return; // Don't call nextStep, FastSpring will handle navigation
            }
        }

        // Check if user selected newsletter (from userDetails, not subscriptionData)
        if(props.userDetails.newsletter){
            subscribeTrial();
            return; // Don't navigate here, FastSpring popup + webhookcallback will handle navigation
        }

        // Reached only when no FastSpring checkout popup was opened
        navigate("/dashboard/stories/1");
    }

    function addFastSpringScript() {

        if( !(window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_SCRIPT_ID && window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_POPUP_STOREFRONT_TRIAL && window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_SRC && window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_DATA_ACCESS_KEY) ) {
            return;
        }
        const scriptId = window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_SCRIPT_ID;
        const existingScript = document.getElementById(scriptId);

        if (!existingScript) {
            const storeFrontToUse = window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_POPUP_STOREFRONT_TRIAL;
            const script = document.createElement("script");

            script.type = "text/javascript";
            script.id = scriptId;
            script.src = window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_SRC;

            script.dataset.storefront = storeFrontToUse;

            // Make sure to add callback function to window so that the DOM is aware of it
            window.popupWebhookCallback = webhookcallback;


            script.setAttribute("data-popup-webhook-received", "popupWebhookCallback");
            script.setAttribute("data-data-callback", "fastSpringCallBack");
            script.setAttribute("data-access-key", window.__RUNTIME_CONFIG__.REACT_APP_FASTSPRING_DATA_ACCESS_KEY);

            document.body.appendChild(script);
        }
    }

    async function webhookcallback(data:any) {
        try {
            setTimeout(() => {
                navigate("/dashboard/stories/1");
            }, 2000)
        }
        catch(err) {
            console.error("Webhook callback error:", err);
        }
    }

    async function subscribe() {
        if(window.fastspring) {
            const payload = {
                contact: {
                    email: props.subscriptionData.email,
                    firstName: props.userDetails.firstname,
                    lastName: props.userDetails.lastname,
                    company: props.subscriptionData.referral // only known field we can send referral id thru Frontend->Fastspring->API
                },
                items:
                    [
                        {
                            product: "3-months-family",
                            quantity: 1,
                        }
                    ]
            }

            // get encrypted data from the api
            const response = await instance.post("/fastspring/encrypt", { payload })
            const { securePayload, secureKey } = response.data

            window.fastspring.builder.secure(securePayload, secureKey)
            window.fastspring.builder.checkout();
        }
    }

    async function subscribeFamilyVip() {
        if(window.fastspring) {
            const payload = {
                contact: {
                    email: props.subscriptionData.email,
                    firstName: props.userDetails.firstname,
                    lastName: props.userDetails.lastname
                },
                items:
                    [
                        {
                            product: "family-vip",
                            quantity: 1,
                        }
                    ]
            }

            // get encrypted data from the api
            const response = await instance.post("/fastspring/encrypt", { payload })
            const { securePayload, secureKey } = response.data

            window.fastspring.builder.secure(securePayload, secureKey)
            window.fastspring.builder.checkout();
        }
    }


    async function subscribeTrial() {
        if(window.fastspring) {
            const payload = {
                contact: {
                    email: props.subscriptionData.email,
                    firstName: props.userDetails.firstname,
                    lastName: props.userDetails.lastname
                },
                items:
                    [
                        {
                            product: "3-months-family",
                            quantity: 1,
                        }
                    ]
            }

            // get encrypted data from the api
            const response = await instance.post("/fastspring/encrypt", { payload })
            const { securePayload, secureKey } = response.data

            window.fastspring.builder.secure(securePayload, secureKey)
            window.fastspring.builder.checkout();
        }
    }
/*
    function setupCountryOptions() {
        const countryOptions :any[] = Object.entries(countries.countries).map(([key, country]) => {
            return(
                {key:country.name, value:country.name}
            );
        }).sort((a, b) => a.key.localeCompare(b.key))

        return countryOptions
    }
*/    

    return(
        <div className="details-container">
            <p className="details-title">{t("Help family connect with you")}</p>
            <button className="underlined-link-button link-to-data-info" onClick={() => setTooltip(true)}>{t("See how your data is used")}</button>

            <Form className="registration-form">
                <Form.Group className="group firstname">
                    <input required autoFocus={true} type="text" className={inputError.firstname.length ? "string-input warning": "string-input"} placeholder={t("First name")} value={props.userDetails.firstname} onChange={(evt) => props.setUserDetails((prev: IUserOptionalData) => { return { ...prev, firstname: evt.target.value }; })} />
                    <Form.Label className="top-label">{t("First name")}</Form.Label>
                    {inputError.firstname.length ? <p className="warning-message">{inputError.firstname}</p> : null}
                </Form.Group>

                <Form.Group className="group lastname">
                    <input required type="text" className={inputError.lastname.length ? "string-input warning": "string-input"} placeholder={t("Last name")} value={props.userDetails.lastname} onChange={(evt) => props.setUserDetails((prev: IUserOptionalData) => { return { ...prev, lastname: evt.target.value }; })} />
                    <Form.Label className="top-label">{t("Last name")}</Form.Label>
                    {inputError.lastname.length ? <p className="warning-message">{inputError.lastname}</p> : null}
                </Form.Group>


                <div className="upload-container" onClick={handleShow}>
                    <img src={profilePicture.length ? profilePicture :  default_avatar} alt="avatar" className="user-picture" />
                    <p className="link-button">{t("Add your photo")}</p>
                    <p className="bottom-label">{t("Optional - add anytime")}</p>                    
                </div>

                {!props.subscriptionData || (props.subscriptionData && !props.subscriptionData.referral) ?
                    <div className="notification-container info">
                        <img src={diamond} alt="Logo" className="diamond" />
                        <p className="notification-title">
                            {props.isMailchimpSubscribed ? 
                            t("1 MONTH PREMIUM FOR FREE") :
                            t("GET 1 MONTH PREMIUM FOR FREE")}</p>
                        <p className="notification-text">{t("Share with up to 10 family members")}</p>
                        <p className="notification-text">{t("Add photos, videos and voice notes")}</p>
                        <p className="notification-text">{t("Full access to premium pages")}</p>
                        <p className="notification-cta-title">
                            {props.isMailchimpSubscribed ? 
                                t("As a newsletter subscriber, this month's premium access is our gift") :
                                t("Subscribe below for monthly family tips and 1 month of premium access")}</p>
                    </div>   
                : null }                                         

                <Form.Group className="checkbox">
                    <div className={`custom-checkbox-container ${props.isMailchimpSubscribed ? "hidden" : null}`}>
                        <input
                            type="checkbox"
                            id="newsletter-checkbox"
                            className="checkbox-input"
                            checked={props.userDetails.newsletter}
                            onChange={() => props.setUserDetails((prev: IUserOptionalData) => { return { ...prev, newsletter: !prev.newsletter }; })}
                        />
                        <label htmlFor="newsletter-checkbox">
                            <p>{(props.subscriptionData && props.subscriptionData.referral) ? t("Subscribe to our family-themed newsletter and receive 1 month of premium access. By subscribing, you agree to our ") : t("Subscribe to our family-themed newsletter. By subscribing, you agree to our ")}
                                <a href="https://www.simirity.com/terms-conditions/" className="underlined-link-button" rel="noreferrer" target="_blank">{t("Terms & Conditions")}</a>
                                {t(" and ")}
                                <a href="https://www.simirity.com/data-privacy/" className="underlined-link-button" rel="noreferrer" target="_blank">{t("Privacy Policy")}</a>
                            </p>
                        </label>
                    </div>
                </Form.Group>

                {/*<Row className="newsletter-row" onClick={() => setShowHubspotModal(true)}>
                    <Col xs={11}>
                        <p className="newsletter-title">{t("Family Newsletter")}</p>
                        <p className="newsletter-description">
                            {t("Dedicated to all things 'family'")}{" "}
                        </p>
                    </Col>
                    <Col className="newsletter-icon-container" xs={1}>
                        <Icon className="right-icon" size={1} path={mdiChevronRight} />
                    </Col>
                </Row>*/}
                {/*<Row className="setting-option-row" onClick={() => setShowHubspotModal(true)}>
                    <Col xs={11}>
                        <p className="settings-title">{t("Family Newsletter")}</p>
                        <p className="settings-description">
                            {t("We dedicate our newsletter to all things 'family'. Sharing Simirity updates and exploring new ideas for your family.")}{" "}
                            <Link to="/dashboard/terms">{t("Terms & Privacy")}</Link>.
                        </p>
                    </Col>
                        <div className="update-container">
                                <div className="monthly-update setting-option-row notifications-row switch-container">
                                    <p className="switch-status">{monthlyNewsletter ? t("On") : t("Off")}</p>
                                    <Switch className={`switch ${monthlyNewsletter ? "active-gold-switch" : ""}`} 
                                            offColor="#17243d"
                                            offHandleColor="#8B919E"
                                            onColor="#006238"
                                            onHandleColor="#006238"
                                            handleDiameter={20}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                            height={14}
                                            width={32}
                                            onChange={(checked) => {props.setUserDetails((prev:IUserOptionalData) => {return {...prev, newsletter: checked}}); setMonthlyNewsletter(checked)}} 
                                            checked={monthlyNewsletter} />
                                </div>                 
                        </div>    
                </Row>  */}              
            </Form>
            <TooltipHelp  {...tooltipData} />
            <Button className="default-button" onClick={() => handleAction()}>{t("Start Family Journal")}<Icon size={1} path={ mdiChevronRight } /></Button>
            <PhotoUploader show={show} handleClose={handleClose} setProfilePicture={setProfilePicture} />
            {/*<HubspotContactModal withoutSidebar show={showHubspotModal} close={() => setShowHubspotModal(false)} />*/}
        </div>
    );
};

export default DetailedRegistrationInformation;